import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closePopup } from "redux/slices/drawerPopupSlice";
import { Drawer } from "antd";
import style from "css/device.module.css";
import Bar from "./bar";
import Bar2 from "./bar2";
import BarPro from "./barPro";
import Board50 from "./board50";
import BoardPro from "./boardPro";
import Frame from "./frame";
import Center from "./center";
import Pad from "./pad";
import Allplace from "pages/solution/allplace";
import DeviceOne from "pages/solution/deviceOne";
import ClickShare from "../thirdParty/clickShare";
import BeGate from "pages/solution/beGate";
import { useMediaQuery } from "react-responsive";
import Presentation from "pages/space/workspace/detail/presentation";
import Nameplate from "../thirdParty/nameplate";
import ZoomPhone from "../thirdParty/zoomPhone";
import Medilink from "pages/solution/medilink";

function NeatPopup() {
  //dispatch
  const dispatch = useDispatch();

  //payload
  const payload = useSelector((state) => state.drawer);

  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const scrollRef = useRef(null);
  const [openShare, setOpenShare] = useState(false);
  const [openDownload, setOpenDownload] = useState(false);
  const drawerClose = () => {
    setOpenShare(false);
    setOpenDownload(false);
    scrollRef.current.scrollTo({ top: 0, left: 0 });
    dispatch(closePopup());
    if (isMobile || isTablet) {
      document.querySelector("#page_header").style.height = "";
    } else {
      document.querySelector("#page_header").style.height = "";
    }
  };
  const scrollToTop = () => {
    scrollRef.current.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const SwitchMenu = () => {
    switch (payload.type) {
      case "bar":
        return <Bar type="popup" />;
      case "bar2":
        return <Bar2 type="popup" />;
      case "barpro":
        return <BarPro type="popup" />;
      case "board50":
        return <Board50 type="popup" />;
      case "boardpro":
        return <BoardPro type="popup" />;
      case "frame":
        return <Frame type="popup" />;
      case "center":
        return <Center type="popup" />;
      case "pad":
        return <Pad type="popup" />;
      case "allplace":
        return <Allplace type="popup" />;
      case "deviceone":
        return <DeviceOne type="popup" />;
      case "clickshare":
        return <Presentation type="popup" />;
      case "begate":
        return <BeGate type="popup" />;
      case "nameplate":
        return <Nameplate type="popup" />;
      case "zoomphone":
        return <ZoomPhone type="popup" />;
      case "medilink":
        return <Medilink type="popup" />;
      default:
        break;
    }
  };
  return (
    <>
      <Drawer
        className="neat_device_popup"
        placement="bottom"
        closable={false}
        onClose={() => drawerClose()}
        open={payload.display}
        size="large"
      >
        <div className={style.device_floating_button_wrapper}>
          <div className={style.device_floating_button_group}>
            <button
              className={style.device_popup_close_btn}
              onClick={() => drawerClose()}
            >
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/common/close.webp"
                }
                alt="close"
              />
            </button>
            <div className={style.device_btn_group_wrap}>
              <div
                className={
                  openShare
                    ? `${style.device_share_group} open`
                    : style.device_share_group
                }
              >
                {openShare ? (
                  <>
                    <button className={style.device_share_btn}>
                      <img
                        src={
                          `${process.env.REACT_APP_CLIENT_URL}` +
                          "img/landing/social/instagram_s.webp"
                        }
                        alt="instagram"
                      />
                    </button>
                    <button className={style.device_share_btn}>
                      <img
                        src={
                          `${process.env.REACT_APP_CLIENT_URL}` +
                          "img/landing/social/facebook_s.webp"
                        }
                        alt="facebook"
                      />
                    </button>
                    <button className={style.device_share_btn}>
                      <img
                        src={
                          `${process.env.REACT_APP_CLIENT_URL}` +
                          "img/landing/social/blog_s.webp"
                        }
                        alt="blog"
                      />
                    </button>
                    <button
                      className={style.device_share_btn}
                      onClick={() => setOpenShare(false)}
                    >
                      <img
                        src={
                          `${process.env.REACT_APP_CLIENT_URL}` +
                          "img/common/close.webp"
                        }
                        alt="close"
                      />
                    </button>
                  </>
                ) : (
                  <button
                    className={style.device_share_btn}
                    onClick={() => setOpenShare(true)}
                  >
                    <img
                      src={
                        `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/common/share.webp"
                      }
                      alt="share"
                    />
                  </button>
                )}
              </div>
              <div
                className={
                  openDownload
                    ? `${style.device_download_group} open`
                    : style.device_download_group
                }
              >
                {openDownload ? (
                  <>
                    <div className={style.device_download_list}>
                      <div className={style.device_download_item}>
                        Frame_Data Sheet
                      </div>
                      <div className={style.device_download_item}>
                        Neat_제품소개서
                      </div>
                    </div>
                    <button
                      className={style.device_share_btn}
                      onClick={() => setOpenDownload(false)}
                    >
                      <img
                        src={
                          `${process.env.REACT_APP_CLIENT_URL}` +
                          "img/common/close.webp"
                        }
                        alt="close"
                      />
                    </button>
                  </>
                ) : (
                  <button
                    className={style.device_share_btn}
                    onClick={() => setOpenDownload(true)}
                  >
                    <img
                      src={
                        `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/common/download.webp"
                      }
                      alt="download"
                    />
                  </button>
                )}
              </div>
            </div>
          </div>

          <button
            className={style.device_popup_scroll_top_btn}
            onClick={() => scrollToTop()}
          >
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` + "img/common/top.webp"
              }
              alt="top"
            />
          </button>
        </div>
        <div
          className={style.device_popup_wrapper}
          ref={scrollRef}
        >
          {<SwitchMenu />}
        </div>
      </Drawer>
    </>
  );
}

export default NeatPopup;
